/* eslint-disable no-process-env -- this is the only file that should be using process.env directly */

/* eslint-disable no-restricted-syntax -- have more than 15 properties as have more than 15 environment variables */
const ProcessEnvironment = {
  ApiGateway: process.env.EXPO_PUBLIC_API_GATEWAY,
  Auth0Audience: process.env.EXPO_PUBLIC_AUTH0_AUDIENCE,
  Auth0ClientId: process.env.EXPO_PUBLIC_AUTH0_CLIENT_ID,
  Auth0Domain: process.env.EXPO_PUBLIC_AUTH0_DOMAIN,
  Auth0PasswordRealm: process.env.EXPO_PUBLIC_AUTH0_PASSWORD_REALM,
  Auth0WebClientId: process.env.EXPO_PUBLIC_AUTH0_WEB_CLIENT_ID,
  BrazeApiKeyAndroid: process.env.EXPO_PUBLIC_BRAZE_API_KEY_ANDROID,
  BrazeApiKeyIOS: process.env.EXPO_PUBLIC_BRAZE_API_KEY_IOS,
  BrazeSDKEndpoint: process.env.EXPO_PUBLIC_BRAZE_SDK_ENDPOINT,
  DatadogClientToken: process.env.EXPO_PUBLIC_DD_CLIENT_TOKEN,
  DatadogRUMApplicationId: process.env.EXPO_PUBLIC_DD_APPLICATION_ID,
  DatadogWebClientToken: process.env.EXPO_PUBLIC_DD_WEB_CLIENT_TOKEN,
  DatadogWebRUMApplicationId: process.env.EXPO_PUBLIC_DD_WEB_APPLICATION_ID,
  DeploymentEnvironment: process.env.EXPO_PUBLIC_ENVIRONMENT,
  EquipPrivacyPolicy: process.env.EXPO_PUBLIC_EQUIP_PRIVACY_POLICY,
  EquipTermsOfUse: process.env.EXPO_PUBLIC_EQUIP_TERMS_OF_USE,
  IntercomApiKeyAndroid: process.env.EXPO_PUBLIC_INTERCOM_API_KEY_ANDROID,
  IntercomApiKeyIOS: process.env.EXPO_PUBLIC_INTERCOM_API_KEY_IOS,
  IntercomAppId: process.env.EXPO_PUBLIC_INTERCOM_APP_ID,
  // this is a LaunchDarkly environment's "mobile key", which is only compatible with the react-native SDK
  LaunchDarklyClientSideId:
    process.env.EXPO_PUBLIC_EQUIP_APPS_LAUNCH_DARKLY_CLIENT_SIDE_ID,
  LaunchDarklyConnectionMode:
    process.env.EXPO_PUBLIC_LAUNCH_DARKLY_CONNECTION_MODE,
  // this is a LaunchDarkly environment's "client side ID", which is only compatible with the react web SDK, used for react-native-web
  LaunchDarklyWebClientSideId:
    process.env.EXPO_PUBLIC_EQUIP_APPS_LAUNCH_DARKLY_WEB_CLIENT_SIDE_ID,
  MixpanelToken: process.env.EXPO_PUBLIC_MIXPANEL_TOKEN,
  MyAppUploadKeyAlias: process.env.MYAPP_UPLOAD_KEY_ALIAS,
  MyAppUploadKeyPassword: process.env.MYAPP_UPLOAD_KEY_PASSWORD,
  MyAppUploadStoreFile: process.env.MYAPP_UPLOAD_STORE_FILE,
  MyAppUploadStorePassword: process.env.MYAPP_UPLOAD_STORE_PASSWORD,
  RequestTimeoutMs: process.env.EXPO_PUBLIC_API_REQUEST_TIMEOUT_MS,
  SendbirdAppId: process.env.EXPO_PUBLIC_SENDBIRD_APP_ID,
  StorybookEnabled: process.env.STORYBOOK_ENABLED,
  WebAppURL: process.env.EXPO_PUBLIC_WEB_APP_URL,
};
/* eslint-enable no-restricted-syntax */

// Record<X,Y> type here enforces that ALL environment variables are used and aliased here
// So that none are missed, and no other information is accidentally included

/* eslint-disable no-restricted-syntax -- have more than 15 properties as have more than 15 environment variables */
const Aliases: Record<
  keyof ProcessEnvironmentVariableNames,
  keyof ProcessEnvironmentType
> = {
  EXPO_PUBLIC_API_GATEWAY: "ApiGateway",
  EXPO_PUBLIC_API_REQUEST_TIMEOUT_MS: "RequestTimeoutMs",
  EXPO_PUBLIC_AUTH0_AUDIENCE: "Auth0Audience",
  EXPO_PUBLIC_AUTH0_CLIENT_ID: "Auth0ClientId",
  EXPO_PUBLIC_AUTH0_DOMAIN: "Auth0Domain",
  EXPO_PUBLIC_AUTH0_PASSWORD_REALM: "Auth0PasswordRealm",
  EXPO_PUBLIC_AUTH0_WEB_CLIENT_ID: "Auth0WebClientId",
  EXPO_PUBLIC_BRAZE_ANDROID_API_KEY: "BrazeApiKeyAndroid",
  EXPO_PUBLIC_BRAZE_IOS_API_KEY: "BrazeApiKeyIOS",
  EXPO_PUBLIC_BRAZE_SDK_ENDPOINT: "BrazeSDKEndpoint",
  EXPO_PUBLIC_DD_APPLICATION_ID: "DatadogRUMApplicationId",
  EXPO_PUBLIC_DD_CLIENT_TOKEN: "DatadogClientToken",
  EXPO_PUBLIC_DD_WEB_APPLICATION_ID: "DatadogWebRUMApplicationId",
  EXPO_PUBLIC_DD_WEB_CLIENT_TOKEN: "DatadogWebClientToken",
  EXPO_PUBLIC_ENVIRONMENT: "DeploymentEnvironment",
  EXPO_PUBLIC_EQUIP_APPS_LAUNCH_DARKLY_CLIENT_SIDE_ID:
    "LaunchDarklyClientSideId",
  EXPO_PUBLIC_EQUIP_APPS_LAUNCH_DARKLY_WEB_CLIENT_SIDE_ID:
    "LaunchDarklyWebClientSideId",
  EXPO_PUBLIC_EQUIP_PRIVACY_POLICY: "EquipPrivacyPolicy",
  EXPO_PUBLIC_EQUIP_TERMS_OF_USE: "EquipTermsOfUse",
  EXPO_PUBLIC_INTERCOM_API_KEY_ANDROID: "IntercomApiKeyAndroid",
  EXPO_PUBLIC_INTERCOM_API_KEY_IOS: "IntercomApiKeyIOS",
  EXPO_PUBLIC_INTERCOM_APP_ID: "IntercomAppId",
  EXPO_PUBLIC_LAUNCH_DARKLY_CONNECTION_MODE: "LaunchDarklyConnectionMode",
  EXPO_PUBLIC_MIXPANEL_TOKEN: "MixpanelToken",
  EXPO_PUBLIC_SENDBIRD_APP_ID: "SendbirdAppId",
  EXPO_PUBLIC_WEB_APP_URL: "WebAppURL",
  MYAPP_UPLOAD_KEY_ALIAS: "MyAppUploadKeyAlias",
  MYAPP_UPLOAD_KEY_PASSWORD: "MyAppUploadKeyPassword",
  MYAPP_UPLOAD_STORE_FILE: "MyAppUploadStoreFile",
  MYAPP_UPLOAD_STORE_PASSWORD: "MyAppUploadStorePassword",
  STORYBOOK_ENABLED: "StorybookEnabled",
};
/* eslint-enable no-restricted-syntax */

type ProcessEnvironmentType = typeof ProcessEnvironment;

export type { ProcessEnvironmentType };
export { Aliases };
export default ProcessEnvironment;
/* eslint-enable no-process-env */
